import httpRequest from '@/services/httpRequest.js'
export default ({
  namespaced: true,
  state: {
    isLoading: false,
    hasMore: true,
    page: 1,
    rows: 10,

    dailyAttendance: {},
    dailyAttendanceList: []
  },
  mutations: {
    SET_IS_LOADING(state, status) {
      state.isLoading = status
    },
    SET_HAS_MORE(state, status) {
      state.hasMore = status;
    },
    RESET_PAGINATION(state) {
      state.page = 1;
      state.hasMore = true;
      state.dailyAttendanceList = [];
    },
    SET_DAILY_ATTENDANCE(state, data) {
      state.dailyAttendance = data;
    },
    SET_DAILY_ATTENDANCE_LIST(state, data) {
      state.dailyAttendanceList = data;
    },
    APPEND_DAILY_ATTENDANCE_LIST(state, newData) {
      state.dailyAttendanceList = [...state.dailyAttendanceList, ...newData]
    },
  },
  actions: {
    async getDailyAttendanceList({ rootState, commit, state }, { isLoadMore = false, params = {} } = {}) {
      if (isLoadMore && !state.hasMore) {
        return false;
      }

      try {
        // Atur halaman dan loading state
        if (!isLoadMore) {
          commit('SET_IS_LOADING', true)
          // await new Promise(resolve => setTimeout(resolve, 500));
          commit('RESET_PAGINATION') // Kembali ke page 1
        } else {
          state.page++ // Naik ke page berikutnya
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherdailyattendance?page=${state.page}&rows=${state.rows}`,
            method: 'GET',
            params: params
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status === 200) {
          const newItems = res.data?.results || res.data || [];

          // Cek apakah data sudah habis (jika yang didapat kurang dari batas rows)
          if (newItems.length < state.rows) {
            commit('SET_HAS_MORE', false);
          }
          if (!isLoadMore) {
            commit('SET_DAILY_ATTENDANCE_LIST', newItems);
          } else {
            commit('APPEND_DAILY_ATTENDANCE_LIST', newItems);
          }

          return true
        }
      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        // Jika load more gagal, kembalikan nomor halaman agar bisa dicoba lagi
        if (isLoadMore) state.page--
      } finally {
        if (!isLoadMore) {
          commit('SET_IS_LOADING', false)
        }
      }

      return false;
    },
  }
})